module.exports = __webpack_public_path__ + "static/web-ui-kit-cover-87cff71c1c093de0fbd804d26561a695.png";